import { createApi } from '@reduxjs/toolkit/query/react';

import { getBaseApiUrl, getGatewayApiVersion } from '@verantos-dev/core-constants';
import { createBaseQuery } from '@verantos-dev/core-utils';

export const baseGatewayApiV1 = createApi({
  reducerPath: 'baseGatewayApiV1',
  baseQuery: createBaseQuery({ version: getGatewayApiVersion(), overrideBaseUrl: getBaseApiUrl() }),
  endpoints: () => ({}), // inject endpoints at the feature level
});
